import React from 'react';
import { Redirect } from 'react-router-dom';
import { Box, Button, Heading, Text } from '@wix/design-system';
import { WIX_STUDIO_HEADER_HEIGHT } from '@wix/core-domain-search';
import { DomainSearchGateModule } from '../../module/domainSearchGate.module';
import { useQueryParams } from '../../hooks/useQueryParams';
export const ConnectErrorRoute = _ref => {
  let {
    onReturnToResults
  } = _ref;
  const {
    getQueryParam
  } = useQueryParams();
  const domainName = getQueryParam('domainName') ?? undefined;
  const metaSiteId = getQueryParam('metaSiteId') ?? undefined;
  if (!domainName || !metaSiteId) {
    return /*#__PURE__*/React.createElement(Redirect, {
      to: "/"
    });
  }
  return /*#__PURE__*/React.createElement(ConnectErrorContent, {
    domainName: domainName,
    metaSiteId: metaSiteId,
    onReturnToResults: onReturnToResults
  });
};
const ConnectErrorContent = _ref2 => {
  let {
    domainName,
    metaSiteId,
    onReturnToResults
  } = _ref2;
  const {
    t
  } = DomainSearchGateModule.internals.useTranslations();
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    width: "100%",
    height: `calc(100dvh - ${WIX_STUDIO_HEADER_HEIGHT})`,
    style: {
      position: 'fixed',
      top: WIX_STUDIO_HEADER_HEIGHT,
      left: 0,
      right: 0,
      bottom: 0
    }
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    flex: "1 1 auto",
    align: "center",
    verticalAlign: "middle",
    padding: "0 SP4",
    textAlign: "center"
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    align: "center",
    width: "100%",
    maxWidth: "360px"
  }, /*#__PURE__*/React.createElement(Heading, {
    size: "large"
  }, t('domain_search_gate.logged_in_mobile.connect_error.title', {
    domainName
  })), /*#__PURE__*/React.createElement(Box, {
    marginTop: "SP3"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "medium",
    secondary: true
  }, t('domain_search_gate.logged_in_mobile.connect_error.description', {
    domainName
  }))), /*#__PURE__*/React.createElement(Box, {
    marginTop: "SP6",
    width: "100%"
  }, /*#__PURE__*/React.createElement(Button, {
    size: "large",
    fullWidth: true,
    onClick: () => onReturnToResults == null ? void 0 : onReturnToResults({
      domainName,
      metaSiteId
    })
  }, t('domain_search_gate.logged_in_mobile.connect_error.cta'))))));
};
//# sourceMappingURL=ConnectErrorRoute.js.map